<dx-popup title="User" [width]="400" [height]="'auto'" [(visible)]="visible" [hideOnOutsideClick]="false" (onHiding)="onHiding($event)">
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-form [formData]="user">
        <dxi-form-item dataField="firstName"> </dxi-form-item>
        <dxi-form-item dataField="lastName"> </dxi-form-item>
        <dxi-form-item dataField="userName"> </dxi-form-item>
        <dxi-form-item dataField="email"> </dxi-form-item>
        <dxi-form-item dataField="windowsUserName"> </dxi-form-item>
        <dxi-form-item dataField="isActive" editorType="dxCheckBox"> </dxi-form-item>
        <dxi-form-item [label]="{ text: 'Roles' }">
            <div *dxTemplate>
                <dx-list
                    [items]="roles"
                    keyExpr="roleId"
                    [(selectedItemKeys)]="selectedRoleIds"
                    selectionMode="multiple"
                    [showSelectionControls]="true"
                    itemTemplate="listItem"
                >
                    <div *dxTemplate="let item of 'listItem'">
                        {{ item.name }}
                    </div>
                </dx-list>
            </div>
        </dxi-form-item>
    </dx-form>
</dx-popup>
